import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

// Auth Views
import Login from 'views/auth/login'

// Dashboard Views
import ApiCallbackManager from 'views/dashboard/apiCallback/ApiCallbackManager'
import ApiTrafficLogsDetail from 'views/dashboard/apiTrafficLogs/ApiTrafficLogsDetail'
import ApiTrafficLogsList from 'views/dashboard/apiTrafficLogs/ApiTrafficLogsManager'
import BankRoutingManager from 'views/dashboard/bankRouting/BankRoutingManager'
import ApiDocumentation from 'views/dashboard/doc/apidoc'
import GlobalCallbackLogDetails from 'views/dashboard/GlobalCallbackLogs/GlobalCallbackLogsDetail'
import GlobalCallbackLogsManager from 'views/dashboard/GlobalCallbackLogs/GlobalCallbackLogsManager'
import InquiryCallbackDetails from 'views/dashboard/inquiryCallback/inquiryCallbackDetail'
import InquiryCallbackManager from 'views/dashboard/inquiryCallback/inquiryCallbackManager'
import InquiryConfigList from 'views/dashboard/inquiryConfigs/InquiryConfigsManager'
import IpWhitelistList from 'views/dashboard/ipWhitelisting/IpWhitelistingManager'
import PaymentVendorsDetail from 'views/dashboard/paymentVendors/paymentVendorsDetail'
import PaymentVendorsManager from 'views/dashboard/paymentVendors/paymentVendorsManager'
import QrisConfigsManager from 'views/dashboard/qrisConfigs/qrisConfigManager'
import QrisExtConfigsManager from 'views/dashboard/qrisExtConfigs/qrisExtConfigsManager'
import SecurityManager from 'views/dashboard/security/SecurityManager'
import DashboardPage from 'views/dashboard/statsDashboard/dashboardPage'
import UserManager from 'views/dashboard/userManager/userManager'
import UserProfile from 'views/dashboard/userManager/userProfile'
import UserSession from 'views/dashboard/userManager/userSession'

// Error Views
import ForbiddenErrorPage from 'views/error/ForbiddenError'
import InternalErrorPage from 'views/error/InternalError'
import NotFoundPage from 'views/error/NotFoundError'
import UnauthorizeErrorPage from 'views/error/UnauthorizeError'

// Layouts
import AuthLayout from 'views/layouts/AuthLayout'
import MainLayout from 'views/layouts/MainLayout'

// Styles
import 'assets/css/react-tabs.css'
import 'assets/css/main.css'
import 'rc-pagination/assets/index.css'
import AuthCookieVerification from 'views/layouts/AuthCookieVerification'

// Safe DOM initialization to avoid "Target container is not a DOM element" crash
const container = document.getElementById('root')

if (!container) {
  throw new Error("Failed to find the root element. Make sure <div id='root'></div> exists in public/index.html")
}

const root = createRoot(container)

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AuthCookieVerification />} />
        {/* Auth Routes */}
        <Route path="/auth" element={<AuthLayout />}>
          <Route path="login" element={<Login />} />
        </Route>

        {/* Dashboard Routes */}
        <Route path="/dashboard" element={<MainLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="users" element={<UserManager />} />
          <Route path="token" element={<UserSession />} />
          <Route path="profile" element={<UserProfile />} />
          <Route path="profile/:id" element={<UserProfile />} />
          <Route path="payment-vendors" element={<PaymentVendorsManager />} />
          <Route path="payment-vendors/add" element={<PaymentVendorsDetail />} />
          <Route path="payment-vendors/:id" element={<PaymentVendorsDetail />} />
          <Route path="bank-routing" element={<BankRoutingManager />} />
          <Route path="ip-whitelisting" element={<IpWhitelistList />} />
          <Route path="qris-configs" element={<QrisConfigsManager />} />
          <Route path="inquiry-configs" element={<InquiryConfigList />} />
          <Route path="qris-ext-configs" element={<QrisExtConfigsManager />} />
          <Route path="api-callback" element={<ApiCallbackManager />} />
          <Route path="inquiry-callback" element={<InquiryCallbackManager />} />
          <Route path="inquiry-callback/:id" element={<InquiryCallbackDetails />} />
          <Route path="global-callback-logs" element={<GlobalCallbackLogsManager />} />
          <Route path="global-callback-logs/:id" element={<GlobalCallbackLogDetails />} />
          <Route path="api-traffic" element={<ApiTrafficLogsList />} />
          <Route path="api-traffic/:id" element={<ApiTrafficLogsDetail />} />
          <Route path="security" element={<SecurityManager />} />
          <Route path="api-doc" element={<ApiDocumentation />} />
        </Route>

        {/* Error Pages */}
        <Route path="/500" element={<InternalErrorPage />} />
        <Route path="/400" element={<UnauthorizeErrorPage />} />
        <Route path="/403" element={<ForbiddenErrorPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
)
